/**
 * One-time migration of localStorage keys from pv-learn-* to mw-*.
 *
 * Runs once on app load. If the migration flag is set, skips.
 * Copies all pv-learn-* values to mw-* equivalents, then removes
 * the old keys. Safe to run multiple times (idempotent).
 */

const MIGRATION_FLAG = 'mw-keys-migrated'

export function migrateLegacyKeys(): void {
  try {
    if (localStorage.getItem(MIGRATION_FLAG)) return

    const keysToMigrate: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key?.startsWith('pv-learn-')) {
        keysToMigrate.push(key)
      }
    }

    for (const oldKey of keysToMigrate) {
      const newKey = oldKey.replace('pv-learn-', 'mw-')
      const value = localStorage.getItem(oldKey)
      if (value !== null && !localStorage.getItem(newKey)) {
        localStorage.setItem(newKey, value)
      }
      localStorage.removeItem(oldKey)
    }

    localStorage.setItem(MIGRATION_FLAG, new Date().toISOString())

    if (keysToMigrate.length > 0) {
      console.info(`[mw] Migrated ${keysToMigrate.length} localStorage keys from pv-learn-* to mw-*`)
    }
  } catch {
    // localStorage not available (SSR, private browsing)
  }
}
